import { DatadogTeam, createDatadogLogger } from '@hotjar/webapp/lib/createDatadogLogger';

const pageBrokenLogger = createDatadogLogger('page-broken', DatadogTeam.Heatmaps);

export function logHeatmapsPageBroken(errorMessage: string): void {
  pageBrokenLogger?.warn('Heatmaps page is broken', {
    errorMessage,
  });
}

export const reportSuccessLogger = createDatadogLogger('report-success', DatadogTeam.Heatmaps);
